export default "__VITE_ASSET__BML5VlfQ__"